
import "./RelationshipsContent.css";

export default function RelationshipsContent() {
  return (
    <div className="_relationship_card">
      <h3 className="_relationship_title">
        Relationships by content type
      </h3>

     
      <div className="_relationship_row">
        <div className="_relationship_left">
          <i className="fa-solid fa-shield-halved _relationship_icon"></i>

          <div className="_relationship_info">
            <p className="_relationship_name">Personal Access</p>
            
          </div>
           <p className="_relationship_rate">50% Rate</p>
          <div className="_relationship_bar">
            <span
              className="_relationship_bar_fill"
              style={{ width: "50%" }}
            ></span>
          </div>
        </div>

        <p className="_relationship_date">Nov 2023</p>
      </div>

   
      <div className="_relationship_row">
        <div className="_relationship_left">
          <i className="fa-solid fa-building _relationship_icon"></i>

          <div className="_relationship_info">
            <p className="_relationship_name">On-site Services</p>
            
          </div>
           <p className="_relationship_rate">80% Rate</p>
          <div className="_relationship_bar">
            <span
              className="_relationship_bar_fill"
              style={{ width: "80%" }}
            ></span>
          </div>
        </div>

        <p className="_relationship_date">Nov 2023</p>
      </div>

    
      <div className="_relationship_row">
        <div className="_relationship_left">
          <i className="fa-solid fa-share-nodes _relationship_icon"></i>

          <div className="_relationship_info">
            <p className="_relationship_name">On-site Services</p>
            
          </div>
           <p className="_relationship_rate">80% Rate</p>
          <div className="_relationship_bar">
            <span
              className="_relationship_bar_fill"
              style={{ width: "80%" }}
            ></span>
          </div>
        </div>

        <p className="_relationship_date">Nov 2023</p>
      </div>
    </div>
  );
}
